import React, { Component, useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { Route, Redirect, Router } from 'react-router';
import { Layout } from './components/presentational-components/Layout';
import { Dashboard } from './components/presentational-components/Dashboard';
import logo from './logo.svg';
import './App.css';
import DeliveryOrder from './components/presentational-components/DeliveryOrder';
import DeliveryOrderContainer from './components/container-components/DeliveryOrderContainer'
import TransactionHistory from './components/container-components/TransactionHistory'
import Sidebar from './components/presentational-components/Sidebar';
import ArticleTypeView from './components/container-components/ArticleTypeView'
import Inventory from './components/container-components/Inventory'
import Inventory1 from './components/container-components/Inventory1'
import MiscelanuousTasks from './components/container-components/MiscelanuousTasks'
import MaintainStock from './components/container-components/MaintainStock';
import IncomingTransactions from './components/container-components/IncomingTransaction'
import OutgoingTransactions from './components/container-components/OutgoingTransaction'
import Login from './components/container-components/Login'
import Logout from './components/container-components/Logout'
import { AppContext } from "./Context";
import MainMenu from './components/presentational-components/MainMenu'
import BaseData from './components/container-components/BaseData';
import TransactionArchive from './components/container-components/TransactionArchive';
import TransactionMenu from './components/presentational-components/TransactionMenu';
import NewSale from './components/container-components/NewSale';
import SaleTransaction from './components/container-components/SaleTransaction'
import SalesBoutique from './components/container-components/SalesBoutique';
import B2COrderBoutique from './components/container-components/B2COrderBoutique';
import LoadingSpinner from './components/presentational-components/LoadingSpinner';
import { FetchBackendPingToPreventTimeout } from './fetcher';
import { CustomerManagement } from './components/container-components/CustomerManagement';


const App = () => {
    const [isAuthenticated, userHasAuthenticated] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(true);

    useEffect(() => {
        onLoad()
    }, []);

    //used for pinning backend every 12 minutes, to let connection stay open and prevent server timeouts
    useEffect(() => {
        const timer = setInterval(() => FetchBackendPingToPreventTimeout(), 720000)
        return () => clearInterval(timer)
    })

    useEffect(() => {
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
    })

    function onLoad() {
        try {
            sessionStorage.getItem("isAuthenticated") != null && sessionStorage.getItem("isAuthenticated") == "true"
                ? userHasAuthenticated(true) : userHasAuthenticated(false)
        }
        catch (e) {
            if (e !== 'No current user') {
                alert(e)
            }
        }

        setIsAuthenticating(false);
    }

    const PrivateRoute = ({ component: Component, ...rest }) => {
        return (

            // Show the component only when the user is logged in
            // Otherwise, redirect the user to /login page
            <Route {...rest} render={props => (
                isAuthenticated ?
                    <Component {...props} />
                    : <Redirect to="/authentication" />
            )} />
        );
    };

    const PublicRoute = ({ component: Component, restricted, ...rest }) => {
        return (
            // restricted == false meaning public route
            // restricted == true meaning restricted route (e.g. /login when already authenticated)
            <Route {...rest} render={props => (
                isAuthenticated && restricted ?
                    <Redirect to="/" />
                    : <Component {...props} />
            )} />
        );
    };

    return (
        <div>
            {!isAuthenticating ?
                <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
                    <Layout>
                        <PrivateRoute exact path='/' component={MainMenu} />
                        <PrivateRoute exact path='/transaction-menu' component={TransactionMenu} />
                        <PrivateRoute path='/delivery-order' component={DeliveryOrderContainer} />
                        <PrivateRoute path='/articles' component={ArticleTypeView} />
                        <PrivateRoute path='/inventory1' component={Inventory1} />
                        <PrivateRoute path='/maintain-stock' component={MaintainStock} />
                        <PrivateRoute path='/incoming-transactions' component={IncomingTransactions} />
                        <PrivateRoute path='/outgoing-transactions' component={OutgoingTransactions} />
                        <PrivateRoute path='/transaction-history' component={TransactionHistory} />
                        <PrivateRoute path='/base-data' component={BaseData} />
                        <PrivateRoute path='/transaction-archive' component={TransactionArchive} />
                        <PrivateRoute path='/new-sale' component={NewSale} />
                        <PrivateRoute path='/sale-transactions' component={SalesBoutique} />
                        <PrivateRoute path='/B2COrder-transactions' component={B2COrderBoutique} />
                        <PrivateRoute path='/customer-management' component={CustomerManagement} />
                        <PrivateRoute path='/miscelaneous-tasks' component={MiscelanuousTasks} />
                        <PrivateRoute path='/logout' component={Logout} />
                        <PublicRoute path='/authentication' component={Login} restricted={true} />

                    </Layout>
                </AppContext.Provider> : null}
        </div>
    );
}

export default App